import React, { useState } from "react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EulaEmailOfferModal = ({ onComplete }) => {
  const [isSending, setIsSending] = useState(false);

  const handleYes = async () => {
    try {
      setIsSending(true);
      const response = await axios.post(
        `${BACKEND_URL}/api/eula/email-copy`,
        {},
        { withCredentials: true }
      );
      
      if (response.data.ok) {
        toast.success("Your agreement copy has been sent. Please check your inbox (and spam folder, just in case).", {
          duration: 5000
        });
      } else {
        toast.warning("We couldn't send the email right now. You can request a copy later from Settings → Account.", {
          duration: 5000
        });
      }
      
      onComplete();
    } catch (error) {
      console.error("Error sending EULA email:", error);
      if (error.response?.status === 429) {
        toast.error(error.response.data.detail || "Please wait before requesting another copy");
      } else {
        toast.warning("We couldn't send the email right now. You can request a copy later from Settings → Account.", {
          duration: 5000
        });
      }
      onComplete();
    } finally {
      setIsSending(false);
    }
  };

  const handleNo = () => {
    onComplete();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="px-6 py-5">
          <h3 className="text-lg font-semibold text-slate-900 mb-3">
            Agreement Confirmed
          </h3>
          <p className="text-sm text-slate-600 mb-6">
            You have successfully accepted the Digital Ink AI™ End User License Agreement.
            <br /><br />
            For your records, we can email you a copy of the agreement you just affirmed, including your name, email address, and the date of acceptance.
          </p>
          
          <div className="flex flex-col gap-3">
            <Button
              onClick={handleYes}
              disabled={isSending}
              className="bg-blue-600 hover:bg-blue-700 text-white w-full"
            >
              {isSending ? "Sending your agreement copy…" : "Yes, Email Me a Copy"}
            </Button>
            <Button
              onClick={handleNo}
              variant="outline"
              disabled={isSending}
              className="w-full"
            >
              No, Continue to Digital Ink AI
            </Button>
          </div>
          
          <p className="text-xs text-slate-500 mt-4 text-center">
            You can request a copy at any time from <span className="font-semibold">Settings → Account</span>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EulaEmailOfferModal;
